import { PayloadAction } from '@reduxjs/toolkit';
import { AddonState } from 'src/store/addon/types';
import { IClipArtResultCategory } from 'src/store/addon/types/clipArtTypes';
import update from 'immutability-helper';

const addClipArtCategoryReducer = (
  state: AddonState,
  action: PayloadAction<IClipArtResultCategory>,
) => {
  if (!action.payload) return state;
  return update<AddonState>(state, {
    clipArtCategories: {
      [action.payload.clipArtCategoryId]: { $set: action.payload },
    },
  });
};

export default addClipArtCategoryReducer;
